import {Button, Flex, IconButton, Tag, Td, Text, Tr} from '@chakra-ui/react';
import React, {useState} from 'react';
import {MdDelete, MdEdit} from 'react-icons/md';
import OptionsMenu from '../../components/OptionsMenu';

const TableRowDisplay = ({
  fields = [],
  item,
  onDeleteClick,
  onEditClick,
}) => {
  const [isDeleteMenuOpen, setIsDeleteMenuOpen] = useState(false);
  const hasActions = !!onEditClick || !!onDeleteClick;

  return (
    <Tr>
      {fields.map(({key, valToLabel = v => v}) => {
        const label = valToLabel(item[key]);
        return (
          <Td key={key}>
            <Flex gap={1}>
              {Array.isArray(label)
                ? label.map(l => <Tag key={l}>{l}</Tag>)
                : label}
            </Flex>
          </Td>
        );
      })}

      {hasActions && (
        <Td>
          {onEditClick && (
            <IconButton
              aria-label="Edit"
              colorScheme="wooorldBlue"
              icon={<MdEdit />}
              marginRight={1}
              onClick={() => onEditClick(item._id)}
              size="xs"
            />
          )}

          {onDeleteClick && (
            <IconButton
              aria-label="Delete"
              colorScheme="red"
              icon={<MdDelete />}
              onClick={() => setIsDeleteMenuOpen(true)}
              size="xs"
            />
          )}

          {isDeleteMenuOpen && (
            <OptionsMenu isOpenPermanently>
              <Text color="white">Delete this item?</Text>
              <Button
                colorScheme="red"
                justifyContent="left"
                onClick={() => {
                  onDeleteClick(item._id);
                }}
                position="relative"
                size="sm"
              >
                confirm
              </Button>

              <Button
                justifyContent="left"
                onClick={() => {
                  setIsDeleteMenuOpen(false);
                }}
                position="relative"
                size="sm"
              >
                cancel
              </Button>
            </OptionsMenu>
          )}
        </Td>
      )}
    </Tr>
  );
};

export default TableRowDisplay;
